export interface IAcceptInvitation {
  password?: string | null;
  lang?: string | null;
  email?: string | null;
}

export interface IInvitationDetails {
  data: IExposedInvitation;
  emailAlreadyInUse: boolean;
}

export interface IExposedInvitation {
  id: number;
  orgName: string;
  email: string;
  role: string;
  status: InvitationStatus;
  expiresAt: string;
  createdAt: string;
}

export enum InvitationStatus {
  PENDING = "PENDING",
  ACCEPTED = "ACCEPTED",
  EXPIRED = "EXPIRED",
  REVOKED = "REVOKED",
}

export enum InvitationCreationErrorCode {
  EMAIL_ALREADY_MEMBER = "EMAIL_ALREADY_MEMBER",
  INVITATION_ALREADY_PENDING = "INVITATION_ALREADY_PENDING",
  SUPER_ADMIN_ONLY = "SUPER_ADMIN_ONLY",
}

export enum InvitationAcceptErrorCode {
  ALREADY_MEMBER = "ALREADY_MEMBER",
}
